<template>
  <v-card>
    <v-card-title class="flex-nowrap">
      <div class="flex-grow-1 flex-shrink-1 pr-4">
        {{ $t(`minimalRequirement.${requirement.requirementId}.name`) }}
      </div>

      <WipSwitch :requirement="requirement" model="minimal" v-if="requirement.state !== 'DONE'" />

      <div>
        <RequirementInfo :requirement="requirement" />
      </div>

      <div class="pl-4">
        <v-btn v-if="!edit" @click="edit = true" color="secondary" icon>
          <v-icon v-if="requirement.state === 'DONE' || requirement.referenced">mdi-eye</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
        </v-btn>

        <v-btn v-if="edit" @click="edit = false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>

    <v-card-text v-if="edit">
      <v-row>
        <v-col cols="4">
          <v-row>
            <v-col cols="12">
              <v-card outlined>
                <v-card-title>
                  {{ $t("user.minimalRequirementForm.description") }}
                </v-card-title>

                <v-card-text>
                  <Markdown :value="$t(`minimalRequirement.${requirement.requirementId}.description`)"></Markdown>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" v-if="$t(`minimalRequirement.${requirement.requirementId}.help`).trim().length > 0">
              <v-card outlined>
                <v-card-title>
                  {{
                    fund.auditPeriod.year > 2024
                      ? $t("user.minimalRequirementForm.help2025")
                      : $t("user.minimalRequirementForm.help")
                  }}
                </v-card-title>

                <v-card-text>
                  <Markdown :value="$t(`minimalRequirement.${requirement.requirementId}.help`)"></Markdown>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="8">
          <v-row>
            <v-col cols="12" v-if="requirement.referenced">
              <ReferenceInfo model="minimal" :fund="fund" :requirement="requirement" />
            </v-col>

            <v-col cols="12" v-if="displayReference">
              <ReferenceForm model="minimal" :requirement="requirement" />
            </v-col>

            <v-col cols="12" v-if="requirement.protocol.length">
              <ResponseList :responses="requirement.protocol" />
            </v-col>

            <v-col cols="12" v-if="requirement.referenced && requirement.pendingResponse">
              {{ $t("pendingResponse.title") }}
              <ResponseList :responses="[requirement.pendingResponse]" />
            </v-col>

            <v-col cols="12" v-if="displayResponseForm">
              <AssistantForm :requirement="requirement" model="minimal" v-if="useAssistant" />

              <RequirementResponseForm
                v-if="!useAssistant"
                type="user"
                model="minimal"
                :requirement="requirement"
                @save="responseForm = false"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ResponseList from "@/components/Fund/ResponseList";
import WipSwitch from "@/components/Requirement/WipSwitch.vue";
import ReferenceForm from "@/components/User/Fund/ReferenceForm";
import ReferenceInfo from "@/components/Requirement/ReferenceInfo";
import RequirementResponseForm from "@/components/Requirement/RequirementResponseForm";
import RequirementInfo from "@/components/Requirement/RequirementInfo";
import AssistantForm from "@/components/User/Fund/AssistantForm";
import assistants from "@fng/common/data/assistants.json";

export default {
  components: {
    WipSwitch,
    ResponseList,
    ReferenceForm,
    ReferenceInfo,
    RequirementInfo,
    RequirementResponseForm,
    AssistantForm,
  },

  props: {
    fund: {
      type: Object,
      required: true,
    },

    requirement: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: null,
      edit: false,
      respond: false,
    };
  },

  computed: {
    displayResponseForm() {
      if (this.requirement.state === "DONE") return false;

      return (
        !this.requirement.mayBeReferenced ||
        !this.requirement.referenceRequirement ||
        (this.requirement.referenced === false && this.requirement.state !== "DONE")
      );
    },

    displayReference() {
      return (
        this.requirement.mayBeReferenced &&
        this.requirement.referenceRequirement &&
        this.requirement.referenced === null
      );
    },

    useAssistant() {
      if (this.requirement.assistantUsed) return false;

      return assistants.some((assistant) => assistant.id === this.requirement.requirementId);
    },
  },
};
</script>
